let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("2YGYU"), load("cGtlr"), load("kIryJ")]).then(() => parcelRequire('j2TUq'));